var map = {
	"./alimentari profilo.svg": 299,
	"./bar profilo.svg": 300,
	"./fastfood profilo.svg": 301,
	"./fruttivendolo profilo.svg": 302,
	"./panificio profilo.svg": 303,
	"./paninoteca profilo.svg": 304,
	"./pizzeria profilo.svg": 305,
	"./rosticceria profilo.svg": 306,
	"./tavolacalda profilo.svg": 307
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 298;